<section class="page-not-found">
  <div class="page-not-found-in">
    <div class="page-not-found-icon mb-1">
      <img src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-not-found.gif" [alt]="'NO_DATA_TO_SHOW' | translate" />
    </div>
    <h3 class="page-not-found-head-text">
      {{ pageNotFoundHeadText | translate }}
    </h3>
    <p class="page-not-found-text">
      {{ pageNotFoundText | translate }}
    </p>
  </div>
</section>
